import { Component } from '@theme/component';

/**
 * A custom element that manages a checkbox input and associated free text input field
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} checkbox - The checkbox input element
 * @property {HTMLInputElement} textInput - The free text input element
 *
 * @extends Component<Refs>
 */

class FreeText extends Component {
  requiredRefs = ['textInput'];

  toggleTextInput() {
    const { checkbox, textInput } = this.refs;
    textInput.classList.toggle('hidden', !checkbox.checked);
    textInput.disabled = !checkbox.checked;
    if (!checkbox.checked) {
      textInput.value = '';
      this.clearValidity();
    }
  }

  handleInvalid() {
    const { textInput } = this.refs;
    textInput.setCustomValidity(textInput.dataset.errorMessage || '');
  }

  clearValidity() {
    const { textInput } = this.refs;
    textInput.setCustomValidity('');
  }
}

if (!customElements.get('free-text')) {
  customElements.define('free-text', FreeText);
}
